<template lang="pug">
.full-width
  v-list.redesignBlack--text
    v-list-item(
      v-for="(item, idx) in navigationListItems"
      :key="idx"
      :to="item.to"
    )
      v-list-item-action
        v-icon(color="redesignBlack") {{ item.icon }}
      v-list-item-content
        v-list-item-title {{ item.text }}
    v-divider
    v-list-item(
      @click="$emit('exit')"
    )
      v-list-item-action
        v-icon(color="redesignBlack") $iexit
      v-list-item-content
        v-list-item-title.redesignError--text(
        ) Выйти
</template>

<script>
import AppButton from '../../controls/AppButton.vue';

export default {
  name: 'MiniHeaderContent',

  components: {
    AppButton,
  },

  computed: {
    navigationListItems() {
      const { isMember, isExpert } = this.$user;
      return [
        {
          icon: '$iuser',
          text: 'Мой профиль',
          to: `${isMember || isExpert ? '/redesign' : ''}/my-profile`,
        },
        {
          hidden: !isMember,
          icon: '$ifolder-favorite-outline',
          text: 'Портфолио',
          to: `/redesign/my-portfolio`,
        },
        {
          icon: '$iinfo',
          text: 'Инструкции',
          to: `${isMember ? '/redesign' : ''}/instructions`,
        },
      ].filter((item) => !item.hidden);
    },
  },
};
</script>
